// Avviso per disdetta anticipata quando il contratto ha una durata minima attiva.
export function avvisoDurataMinima(c) {
  const anni = parseInt(c?.durata_minima_anni, 10);
  if (!anni || !c?.data_inizio) return null;
  const fine = new Date(String(c.data_inizio).slice(0, 10));
  if (isNaN(fine)) return null;
  fine.setFullYear(fine.getFullYear() + anni);
  const oggi = new Date();
  if (oggi >= fine) return null;
  let mesi = (fine.getFullYear() - oggi.getFullYear()) * 12 + (fine.getMonth() - oggi.getMonth());
  if (fine.getDate() < oggi.getDate()) mesi -= 1;
  const a = Math.floor(mesi / 12);
  const m = mesi % 12;
  const resto = [a > 0 ? `${a} ${a === 1 ? 'anno' : 'anni'}` : '', m > 0 ? `${m} ${m === 1 ? 'mese' : 'mesi'}` : '']
    .filter(Boolean).join(' e ') || 'meno di un mese';
  const fineIt = `${String(fine.getDate()).padStart(2, '0')}/${String(fine.getMonth() + 1).padStart(2, '0')}/${fine.getFullYear()}`;
  const penale = (c.penale_uscita || '').trim() || 'canoni residui al momento della disdetta';
  return `⚠️ DURATA MINIMA DI ${anni} ${anni === 1 ? 'ANNO' : 'ANNI'} ATTIVA\n\nAl termine del periodo minimo mancano ${resto} (fino al ${fineIt}).\nPenale uscita anticipata applicabile: ${penale}.`;
}
